<template>
	<div class="foot">
		<div class="footInner">
			<ul class="footUl">
				<li>
					<img src="../assets/images/zphy.png" class="liIcon"/>
					<div>
						<div class="liTitle">{{$t('components.foot2.perk1.title')}}</div>
						<div class="liText">{{$t('components.foot2.perk1.text')}}</div>
					</div>
				</li>
				<li>
					<img src="../assets/images/qhbz.png" class="liIcon"/>
					<div>
						<div class="liTitle">{{$t('components.foot2.perk2.title')}}</div>
						<div class="liText">{{$t('components.foot2.perk2.text')}}</div>
					</div>
				</li>
				<li>
					<img src="../assets/images/zskf.png" class="liIcon"/>
					<div>
						<div class="liTitle">{{$t('components.foot2.perk3.title')}}</div>
						<div class="liText">{{$t('components.foot2.perk3.text')}}</div>
					</div>
				</li>
				<li>
					<img src="../assets/images/zsjg.png"  class="liIcon"/>
					<div>
						<div class="liTitle">{{$t('components.foot2.perk4.title')}}</div>
						<div class="liText">{{$t('components.foot2.perk4.text')}}</div>
					</div>
				</li>
			</ul>
			<div class="footMiddle">
				<div class="footLists">
					<ul class="footList">
							<li class="footListTitle">{{$t('components.foot2.shoppingGuide')}}</li>
							<router-link to="/guide"><li>{{$t('components.foot2.guideUsage')}}</li></router-link>
					</ul>
					<ul class="footList" v-if="currentLanguage === 'zh-CN'">
							<li class="footListTitle">{{$t('components.foot2.payMethods')}}</li>
							<router-link :to="{path:'/guide',query:{type:'InvoiceApply'}}"><li>{{$t('components.foot2.payInvoiceInfo')}}</li></router-link>
							<router-link :to="{path:'/guide',query:{type:'ToPay'}}"><li>{{$t('components.foot2.howToPay')}}</li></router-link>
					</ul>
					<ul class="footList" v-if="currentLanguage === 'zh-CN'">
							<li class="footListTitle">{{$t('components.foot2.servicePolicy')}}</li>
							<router-link :to="{path:'/guide',query:{type:'Agreement'}}"><li>{{$t('components.foot2.userAgreement')}}</li></router-link>
							<router-link :to="{path:'/guide',query:{type:'PrivacyPolicy'}}"><li>{{$t('components.foot2.privacyPolicy')}}</li></router-link>
							<router-link :to="{path:'/guide',query:{type:'SalePolicy'}}"><li>{{$t('components.foot2.saleService')}}</li></router-link>
					</ul>
					<ul class="footList">
							<li class="footListTitle">{{$t('components.foot2.contentCenter')}}</li>
							<li v-if="currentLanguage === 'zh-CN'">{{$t('components.foot2.latestInfo')}}</li>
							<li v-if="currentLanguage === 'zh-CN'">{{$t('components.foot2.importantNotice')}}</li>
							<router-link to="/download"><li>{{$t('components.foot2.sampleDownload')}}</li></router-link>
					</ul>
					<ul class="footList" v-if="currentLanguage === 'zh-CN'">
							<li class="footListTitle">{{$t('components.foot2.personalCenter')}}</li>
							<router-link v-if="isLogin" :to="{path:'/my',query:{type:'ORDER',state:0}}"><li>{{$t('components.foot2.orderManage')}}</li></router-link>
							<router-link  v-if="isLogin" :to="{path:'/my',query:{type:'INVOICEINFO'}}"><li>{{$t('components.foot2.invoiceManage')}}</li></router-link>
							<router-link v-if="!isLogin" to="/"><li>{{$t('components.foot2.orderManage')}}</li></router-link>
							<router-link v-if="!isLogin" to="/"><li>{{$t('components.foot2.invoiceManage')}}</li></router-link>
					</ul>
					<ul class="footList">
							<li class="footListTitle">{{$t('components.foot2.aboutUs')}}</li>
							<router-link :to="{path:'/guide',query:{type:'Platform'}}"><li>{{$t('components.foot2.platformIntro')}}</li></router-link>
							<router-link :to="{path:'/guide',query:{type:'Contact'}}"><li>{{$t('components.foot2.contactUs')}}</li></router-link>
					</ul>
				</div>
				<div class="footInfo">
					<img  src="../assets/images/logo3.png" class="footLogo"/>
						<div class="footTitle">{{$t('components.foot2.platformTagline')}}</div>
					<div class="line3"></div>
						<div class="workTime">{{$t('components.foot2.workTime')}}</div>
					<div class="workTel">
						<img src="../assets/images/telGray.png" class="telGray"/>
						<div>18862938532</div>
					</div>
						<div class="workTel">
						<img src="../assets/email.png" class="emailGray"/>
						<div>admin@ntroke.com</div>
					</div>
				</div>
				<div class="footMa">
					<img  src="../assets/images/ma1.jpg" class="ma1"/>
						<div class="maText">{{$t('components.foot2.customerWechat')}}</div>
				</div>
			</div>
			<div class="line4"></div>
				<div class="footText">{{$t('components.foot2.publicSecurity')}}</div>
				<div class="footText">{{$t('components.foot2.copyright')}}</div>
		</div>
		
	</div>
</template>

<script>
	export default 
	{
		data() {
			return {
				isLogin: false,
				currentLanguage: localStorage.getItem("locale-lang") || "zh-CN",
			}
		},
		created() {
			this.checkLogin();
		},
		methods: {
			checkLogin()
			{
				this.$scUtil.checkLogin(this, res => {
					if (res) {
						//console.log(res);
						this.isLogin=true;
						//this.userName=localStorage.getItem('username');
					}
				});
			},
		},
	}
</script>

<style scoped>
	.foot{
		width:100%;
		height: 468px;
		background-color: #505153;
		display:flex;
		justify-content: center;
	}
	
	.footInner{
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	ul li{
		list-style: none;
	}
	
	.footUl{
		display: flex;
		color: #fff;
		padding:0 118px;
		box-sizing: border-box;
		width: 1200px;
		margin-top: 35px;
	}
	
	.footUl li{
		display: flex;
		align-items: center;
		flex: 1;
	}
	
	.liTitle{
		font-size: 19px;
		font-weight: bolder;
	}
	
	.liText{
		font-size: 12px;
		margin-top: 10px;
	}
	
	.liIcon{
		margin-right: 15px;
	}
	
	.footLists{
		display: flex;
		align-items: flex-start;
		color: #fff;
		font-size: 12px;
		color: #cccccc;
		margin-left: 32px;
	}
	
	.footListTitle{
		font-size: 16px;
		font-weight: bolder;
		color: #fff;
	}
	
	.footList{
		margin-right: 56px;
	}
	
	.footList li{
		line-height: 30px; 
	}
	
	.footMiddle{
		margin-top: 34px;
		display: flex;
		align-items: center;
		width: 1200px;
		justify-content: center;
	}
	
/* 	.footLogo{
		width: 124px;
		height: 44px;
	} */
	
	.telGray{
		width:21px;
		height:21px;
		margin-right: 11px;
	}
	
	.emailGray{
		width:20px;
		height:16px;
		margin-right: 11px;
	}
	
	.footTitle{
		font-size: 13px;
		color: #fff;
		margin-top: 12px;
	}
	
	.line3{
		width: 166px;
		height: 1px;
		background-color: #777777;
		margin: 9px 0; 
	}
	
	.workTime{
		font-size: 12px;
		color: #cccccc;
	}
	
	.workTel{
		display: flex;
		font-size: 21px;
		color: #cccccc;
		font-weight: bolder;
		align-items: center;
		margin-top: 15px;
	}
	
	.footInfo{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.footMa{
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-left:60px;
	}
	
	.ma1{
		width: 91px;
		height: 91px;
	}
	
	.maText{
		font-size: 13px;
		color: #fff;
		margin-top: 15px;
	}
	
	.line4{
		width: 1145px;
		height: 1px;
		background-color: #777777;
		margin-top: 30px;
		margin-bottom:10px;
	}
	
	.footText{
		font-size:12px;
		color: #cccccc;
		margin-top: 15px;
	}

	.router-link-active{
		color: #cccccc;
	}

	a{
		color: #cccccc;
	}
	
</style>